<template>
  <zt-dialog
    title="联系客服"
    :visible="dialogKf"
    :append-to-body="true"
    :modal-append-to-body="false"
    width="668px"
    @close="$store.commit('CLOSE_DIALOG_KF')"
  >
    <el-row>
      <el-col :span="12">
        <div class="card">
          <img :src="wechat_kf" />
          <div class="buttom-info fx-between">
            <div class="logo">
              <svg-icon icon="wechat"></svg-icon>
            </div>
            <div class="text-left fx1">
              <div class="title">微信客服id</div>
              <div class="content">shenghuomei_mumu</div>
              <div class="title">在线时间</div>
              <div class="content">节假日09:00-18:00</div>
            </div>
            <!-- <zt-button class="copy"
              type="yellow"
              plain
              size="mini"
              v-copy.text
              data-copy-text="shenghuomei_mumu"
            >复制</zt-button>-->
            <zt-button
              class="copy"
              type="yellow"
              plain
              size="mini"
              v-copy.text
              data-copy-text="shenghuomei_mumu"
            >复制</zt-button>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="card">
          <img :src="qq_kf" />
          <div class="buttom-info fx-between">
            <div class="logo">
              <svg-icon icon="qq"></svg-icon>
            </div>
            <div class="text-left fx1">
              <div class="title">QQ客服</div>
              <div class="content">1814846507</div>
              <div class="title">在线时间</div>
              <div class="content">工作日09:00-18:00</div>
            </div>
            <zt-button
              class="copy"
              type="yellow"
              plain
              size="mini"
              v-copy.text
              data-copy-text="1814846507"
            >复制</zt-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </zt-dialog>
</template>

<script>
import Clipboard from 'clipboard';
import { Message } from 'element-ui';
import wechat_kf from '@imgs/wechat_kf.png';
import qq_kf from '@imgs/qq_kf.png';

export default {
  computed: {
    dialogKf() {
      return this.$store.getters.dialogKf;
    },
  },
  data: () => ({
    // BASE_URL: process.env.BASE_URL,
    visible: true,

    wechat_kf,
    qq_kf,
  }),
  directives: {
    copy: {
      inserted(el, { modifiers }) {
        let options = {};
        if (modifiers.text) {
          Object.assign(options, {
            text: (trigger) => {
              return trigger.dataset.copyText;
            },
          });
        }
        el.clipboard = new Clipboard(el, options);
        el.clipboard.on('success', () => {
          Message.success('复制成功');
          window.getSelection().empty();
        });
        el.clipboard.on('error', () => {
          Message.success('该浏览器不支持自动复制');
          window.getSelection().empty();
        });
      },
      unbind(el) {
        el.clipboard.destroy();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 16px 20px 35px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .el-row {
    width: 618px;
    margin: 0 auto;
  }
  .el-col + .el-col {
    border-left: 1px solid $theme-border3;
  }
}
.card {
  width: 309px;
  text-align: center;
  img {
    width: 180px;
  }
  .text-left{
    text-align: center;
  }
  .buttom-info {
    width: 285px;
    padding: 0 16px;
    margin: 0 auto;
    margin-top: 36px;
    .svg-icon {
      width: 32px;
      height: 32px;
      margin-right: 15px;
    }
    .title {
      color: $theme-textsecond;
      font-size: 12px;
    }
    .content {
      font-size: 14px;
      line-height: 22px;
    }
    .copy {
      width: 40px;
      height: 24px;
      line-height: 24px;
      padding: 0;
      text-align: center;
      margin-left: 14px;
    }
  }
}
</style>
